module.exports = __webpack_public_path__ + "static/media/restaurant.c46ee690.svg";